import { actionTypes } from './constants';
import { getActionWithDefaultData } from 'helpers/actionHelper';


const initialState = {
    assetInfo: {
        data: [],
        loadingStatus: null,
    },
    sensorFeatures: {
        data: [],
        loadingStatus: null,
    },
    sensorProperties: {
        data: [],
        loadingStatus: null,
    },
    gatewayInfo: {
        data: [],
        loadingStatus: null,
    },
    sensorGatewayInfo: {
        data: {},
        loadingStatus: null
    },
    sensorTimeseriesInfo: {
        data: [],
        loadingStatus: null
    },
    sensorTimeseriesConfig: {
        data: [],
        loadingStatus: null
    },
    sensorRssiValue: {
        data: [],
        loadingStatus: null
    },
    sensorBatteryLevel: {
        data: null,
        loadingStatus: null
    }
};


export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_ASSET_INFO:
            return {
                ...state,
                assetInfo: getActionWithDefaultData(action, initialState.assetInfo)
            };
        case actionTypes.GET_SENSOR_FEATURES:
            return {
                ...state,
                sensorFeatures: getActionWithDefaultData(action, initialState.sensorFeatures)
            };
        case actionTypes.GET_SENSOR_PROPERTIES:
            return {
                ...state,
                sensorProperties: getActionWithDefaultData(action, initialState.sensorProperties)
            };

        case actionTypes.GET_SENSOR_GATEWAYINFO:
            return {
                ...state,
                sensorGatewayInfo: {
                    data: action.data,
                    loadingStatus: action.loadingStatus,
                    error: action?.error
                }
            };
        case actionTypes.GET_GATEWAY_INFO:
            return {
                ...state,
                gatewayInfo: getActionWithDefaultData(action, initialState.gatewayInfo)
            };
        case actionTypes.GET_SENSOR_TIMESERIES_CONFIG:
            return {
                ...state,
                sensorTimeseriesConfig: getActionWithDefaultData(action, initialState.sensorTimeseriesConfig)
            };
        case actionTypes.GET_SENSOR_TIMESERIES:
            return {
                ...state,
                sensorTimeseriesInfo: getActionWithDefaultData(action, initialState.gatewayInfo)
            };
        case actionTypes.GET_SENSOR_RSSI_VALUE:
            return {
                ...state,
                sensorRssiValue: getActionWithDefaultData(action, initialState.sensorRssiValue)
            };
        case actionTypes.GET_SENSOR_BATTERY_LEVEL:
            return {
                ...state,
                sensorBatteryLevel: getActionWithDefaultData(action, initialState.sensorBatteryLevel)
            };
        case actionTypes.CLEAR_STORE:
            return {
                ...state,
                assetInfo: { ...initialState.assetInfo },
                sensorFeatures: { ...initialState.sensorFeatures },
                sensorProperties: { ...initialState.sensorProperties },
                gatewayInfo: { ...initialState.gatewayInfo },
                sensorGatewayInfo: { ...initialState.sensorGatewayInfo },
                sensorTimeseriesConfig: { ...initialState.sensorTimeseriesConfig },
                sensorTimeseriesInfo: { ...initialState.sensorTimeseriesInfo },
                sensorRssiValue: { ...initialState.sensorRssiValue },
                sensorBatteryLevel: { ...initialState.sensorBatteryLevel },
            };
        case actionTypes.CLEAR_TIMESERIES_STORE:
            return {
                ...state,
                sensorTimeseriesInfo: { ...initialState.sensorTimeseriesInfo },
                sensorRssiValue: { ...initialState.sensorRssiValue },
            };
        default:
            return state;
    }
};
